import { useMemo } from "react";

import { BlockSpinner } from "@game/Blocks/BlockSpinner";
import { BlockLimbo } from "@game/Blocks/BlockLimbo";
import { BlockStart } from "@game/Blocks/BlockStart";
import { BlockAxe } from "@game/Blocks/BlockAxe";
import { BlockEnd } from "@game/Blocks/BlockEnd";
import { Floor } from "@game/Floor";

export function Level({ seed = 0, count = 5, size = 4, types = [BlockSpinner, BlockAxe, BlockLimbo], bad }) {
    const blocks = useMemo(() => {
        const blocks = [];

        for (let i = 0; i < count; i++) {
            const type = types[Math.floor(Math.random() * types.length)];
            blocks.push(type);

        }
        return blocks
    }, [count, types, seed]);

    return (
        <>
            <BlockStart position={[0, 0, 0]} />

            {blocks.map((Block, index) => <Block key={index} bad={bad} position={[0, 0, - (index + 1) * size]} />)}

            <BlockEnd position={[0, 0, - (count + 1) * size]} />

            <Floor length={count + 2} size={size} />
        </>
    )
}